import axios from "shared/lib/GolAxios";
import { createResponse } from "shared/lib/functions";
import { getExportFoodRequestObject } from "shared/lib/golRequestObjects";

export async function getFood() {
  const request = await getExportFoodRequestObject();
  const response = await axios.post("", request);

  return createResponse(response);
}
